module.exports = {"name":"Detail osoby","icon":"<i class='material-icons'>person</i>","widget":[{"type":"detail","initData":{},"api":{"url":"persons/detail","id":"personId"},"groups":[]}]}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/person-detail/person-detail.json
// module id = 379
// module chunks = 0